import type { FC } from 'react';
import React from 'react';

export const ConditionalRender: FC<{ condition: boolean }> = ({
  children,
  condition,
}) => {
  return <>{condition && children}</>;
};
